module.exports = __webpack_public_path__ + "assets/img/247601.7da2d17a.svg";